import { Group, Menu, Table } from '@mantine/core';
import { IconEdit, IconTrash } from '@tabler/icons-react';
import { useMemo } from 'react';
import { useParams } from 'react-router';
import { DeleteModal } from '../../../components/DeleteModal';
import { TableRowMenu } from '../../../components/TableRowMenu';
import { useModal } from '../../../hooks/useModal';
import { defaultIconStyle } from '../../../theme/styling/iconStyling';
import { mutate } from '../../../util/api/mutate';
import type { GroupDto } from '../types/GroupDto';
import { EditGroupModal } from './EditGroupModal';
import { KeyedRow } from '../../../components/KeyedRow';

interface GroupRowProps {
	group: GroupDto;
	triggerListUpdate: () => void;
}

export function GroupRow({ group, triggerListUpdate }: GroupRowProps) {
	const { organisation } = useParams();

	const editModal = useModal();
	const deleteModal = useModal();

	const editGroupDto = useMemo(() => {
		const editGroup: GroupDto = {
			groupName: group.groupName,
			id: group.id.toString(),
		};

		return editGroup;
	}, [group]);

	const deleteMutation = mutate<boolean>(
		`${organisation}/groups/delete/${group.id.toString()}`,
	);

	return (
		<>
			<DeleteModal
				close={deleteModal.close}
				isOpened={deleteModal.isOpen}
				titleType={'Group'}
				itemDescription={group.groupName}
				mutation={deleteMutation}
				onComplete={(): void => {
					triggerListUpdate();
				}}
			/>
			<EditGroupModal
				isOpened={editModal.isOpen}
				close={editModal.close}
				triggerListUpdate={triggerListUpdate}
				initialGroup={editGroupDto}
			/>
			<KeyedRow>
				<Table.Td>{group.groupName}</Table.Td>
				<Table.Td>
					<Group justify={'center'}>{group.departmentsCount}</Group>
				</Table.Td>
				<Table.Td>
					<TableRowMenu>
						<Menu.Item
							leftSection={<IconEdit {...defaultIconStyle} />}
							onClick={() => editModal.open()}
						>
							Edit
						</Menu.Item>
						<Menu.Item
							leftSection={<IconTrash {...defaultIconStyle} />}
							onClick={() => deleteModal.open()}
							c={'red'}
						>
							Delete
						</Menu.Item>
					</TableRowMenu>
				</Table.Td>
			</KeyedRow>
		</>
	);
}
